import type { ICard } from "../../cardsSlice";

export const major17Card: ICard = {
    id: "major_17",
    arcana: "major",
    number: 17,
    suit: "major",
    court: "major",
    name: "Звезда",
    nameEn: "The Star",
    keywords: ["Надежда", "Вдохновение", "Обновление"],
    symbolism: ["Женщина, льющая воду из кувшинов", "Большая звезда и семь малых", "Птица, обнажённость, ландшафт"],
    symbolismInterpretation:
      "Образ исцеления, открытости, связи с источником вдохновения и веры",
    archetype: "Свет после бури, архетип обновления и духовного очищения",
    psychology: "Возвращение веры, надежда после трудностей, вдохновение",
    upright: {
      personality: "Доверие миру, внутренний свет",
      relationships: "Открытость, восстановление близости",
      work: "Новые идеи, продвижение через вдохновение",
      spirituality: "Связь с высшим источником, чистота намерений",
      examples: ["Спокойный этап", "Вдохновляющее обновление", "Возвращение к себе"]
    },
    reversed: {
      meaning: "Утрата веры, пессимизм, потеря ориентиров",
      nuances: "Ощущение беспомощности, закрытость от вдохновения"
    },
    associations: ["Свет", "Надежда", "Чистота", "Вода"],
    combinations: ["С Башней — возрождение после разрушений", "С Луной — интуитивное прозрение"],
    readingTips: ["Поддерживать доверие", "Видеть потенциал обновления"],
    selfQuestions: ["Во что я верю?", "Что наполняет меня надеждой?"]
  };


